import { ProductColumnHeader } from "src/enums";
import { POProductConfirmation, Product, TableColumn } from "src/types";
import { Table } from "../ui";

interface ParentPOProductsTableProps {
  products?: Product[];
  productConfirmationData?: POProductConfirmation[];
}

const ParentPOProductsTable: React.FC<ParentPOProductsTableProps> = ({ products, productConfirmationData }) => {
  if (!products || products.length === 0) {
    return null;
  }

  const parentPOProductsColumns: TableColumn<ProductColumnHeader, Product>[] = [
    {
      header: ProductColumnHeader.ID,
      column: (row: Product) => <span className="font-medium text-neutral-900">{row.id}</span>,
      styles: { minWidth: "140px", width: "140px" }
    },
    {
      header: ProductColumnHeader.SKU,
      column: (row: Product) => <span className="text-neutral-700">{row.skuName}</span>,
      styles: { minWidth: "140px", width: "140px" }
    },
    {
      header: ProductColumnHeader.NAME,
      column: (row: Product) => <span className="text-neutral-900">{row.name}</span>,
      styles: { minWidth: "250px" }
    },
    {
      header: ProductColumnHeader.SIZE,
      column: (row: Product) => <span className="text-neutral-700">{row.size || "-"}</span>,
      styles: { minWidth: "100px", width: "100px" }
    }
  ];

  if (products?.some((product) => product.extraInfo)) {
    parentPOProductsColumns.push({
      header: ProductColumnHeader.EXTRA_INFO,
      column: (row: Product) => <span className="text-neutral-700">{row.extraInfo || "-"}</span>,
      styles: { minWidth: "120px", width: "120px" }
    });
  }

  parentPOProductsColumns.push(
    {
      header: ProductColumnHeader.BARCODE,
      column: (row: Product) => <span className="font-mono text-neutral-900">{row.barcode}</span>,
      styles: { minWidth: "140px", width: "140px" }
    },
    {
      header: ProductColumnHeader.ORDER_QUANTITY,
      column: (row: Product) => <span className="font-semibold text-neutral-900">{row.quantity.toString()}</span>,
      styles: { minWidth: "120px", width: "120px", textAlign: "center" }
    }
  );

  if (productConfirmationData) {
    parentPOProductsColumns.push({
      header: ProductColumnHeader.CONFIRMED_QTY,
      column: (row: Product) => {
        const confirmedQty = productConfirmationData?.find(
          (productConfirmation) => productConfirmation.productId === row.id
        )?.confirmedQty;
        return <span className="font-semibold text-success-700">{confirmedQty?.toString() ?? "-"}</span>;
      },
      styles: { minWidth: "140px", width: "140px", textAlign: "center" }
    });
  }

  parentPOProductsColumns.push({
    header: ProductColumnHeader.RECEIVED_QTY,
    column: (row: Product) => {
      const receivedQty = row.receivedQty;
      return <span className="font-semibold text-neutral-900">{receivedQty?.toString() ?? "-"}</span>;
    },
    styles: { minWidth: "140px", width: "140px", textAlign: "center" }
  });

  return <Table<ProductColumnHeader, Product> data={products} columns={parentPOProductsColumns} />;
};

export { ParentPOProductsTable };
